// Map our custom plan IDs ("basic", "premium", etc) to Stripe price IDs
const stripePriceIds = {
  pro: process.env.NEXT_PUBLIC_STRIPE_MONTHLY_PAYMENT,
  proyear: process.env.NEXT_PUBLIC_STRIPE_ANNUAL_PAYMENT,
  team: process.env.NEXT_PUBLIC_STRIPE_PRICE_TEAM,
  teamyear: process.env.NEXT_PUBLIC_STRIPE_PRICE_TEAMYEAR,
  onelifetime: process.env.NEXT_PUBLIC_STRIPE_PRICE_ONELIFETIME,
  threelifetime: process.env.NEXT_PUBLIC_STRIPE_PRICE_THREELIFETIME,
  fivelifetime: process.env.NEXT_PUBLIC_STRIPE_PRICE_FIVELIFETIME,
};

// Get Stripe priceId
export function getStripePriceId(planId) {
  return stripePriceIds[planId];
}

// Get friendly plan ID ("basic", "premium", etc) by Stripe plan ID
// Used in auth.js to include planId in the user object
export function getFriendlyPlanId(stripePriceId) {
  return Object.keys(stripePriceIds).find(
    (key) => stripePriceIds[key] === stripePriceId
  );
}
